import React from "react";
import { ImageDimension } from "@plugins/gatsby-source-paligo/src/types";
import { ContentstackImage } from "@singlestore/fusion/components/image";

import "./Image.scss";

// max size content can be at given breakpoints
const MAX_CONTENT_SIZE = {
    lg: 850,
    md: 710,
};

type PictureProps = {
    src: string;
    alt?: string;
    dimension?: ImageDimension;
    halfWidth?: boolean;
};

export function ImageFigure({
    children,
    ...rest
}: React.PropsWithChildren & React.HTMLProps<HTMLElement>) {
    return (
        <figure className="image-figure" {...rest}>
            {children}
        </figure>
    );
}

export function ImageCaption({
    children,
    ...rest
}: React.PropsWithChildren & React.HTMLProps<HTMLElement>) {
    return (
        <figcaption className="image-caption" {...rest}>
            {children}
        </figcaption>
    );
}

export function Image({ src, alt = "", dimension, halfWidth }: PictureProps) {
    const sizes = {
        lg: halfWidth
            ? Math.floor(MAX_CONTENT_SIZE.lg / 2)
            : MAX_CONTENT_SIZE.lg,
        md: halfWidth
            ? Math.floor(MAX_CONTENT_SIZE.md / 2)
            : MAX_CONTENT_SIZE.md,
    };

    return (
        <ContentstackImage
            src={src}
            alt={alt}
            className="image"
            sizes={sizes}
            {...dimension}
        />
    );
}
